import { Helmet, HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from '@tanstack/react-router';

import { router } from './App.router';
// import { useLoadScript } from './App.hooks';

import './App.css';
import { useTrackingInstallion } from '@/tracking/Tracking.hooks';
import { tryRefreshToken } from '../basic/auth/Auth.hooks';
import { useInterval } from '@/App.hooks';
import { useIsOnline, useOfflineQueryPersistence } from '@/hooks';
import { useContext } from 'react';
import { AppContext } from '@/App.context';
import { Assets } from '@/assets';

function App() {
	const isOnline = useIsOnline();
	const { queryRequest } = useContext(AppContext);
	// useLoadScript();
	useTrackingInstallion();
	useOfflineQueryPersistence();
	// const INTERVAL_TIME = 5 * 60 * 1000;
	const INTERVAL_TIME = 30 * 1000;
	useInterval(() => {
		if (!isOnline) return;
		tryRefreshToken('/', { minutes: 1 }, queryRequest);
	}, INTERVAL_TIME);

	const classNames = ['App'];
	return (
		<Assets>
			<HelmetProvider>
				<Helmet>
					<meta
						name="theme-color"
						content={isOnline ? '#fff' : '#f00'}
					/>
				</Helmet>
				<div className={classNames.join(' ')}>
					<RouterProvider router={router} />
				</div>
			</HelmetProvider>
		</Assets>
	);
}

export default App;
